import { Button, useToggle } from '@factorialco/deprecated-design-system'
import { GetCalendarSyncsDocument, InviteCalendarSyncDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { InviteUserModal } from './InviteUserModal'

export const InviteUserButton = () => {
  const [showUsersModal, toggleUsersModal] = useToggle(false)

  const [inviteUser] = useMutation(InviteCalendarSyncDocument, {
    extractorFn: (data) => data.cronofySchedulingMutations.inviteCronofyschedulingCalendarSync,
  })

  const onClose = toggleUsersModal(false)
  const onInvite = async (accessId: number) => {
    onClose()

    const result = await inviteUser({
      variables: { accessId },
      refetchQueries: [GetCalendarSyncsDocument],
      awaitRefetchQueries: true,
    })
    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('cronofy.invite_user.success_message'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('cronofy.invite_user.error_message'),
      })
    }
  }

  return (
    <>
      {showUsersModal && <InviteUserModal onClose={onClose} onInvite={onInvite} />}
      <Button onClick={toggleUsersModal(true)}>{i18n.t('cronofy.invite_user.invite_user')}</Button>
    </>
  )
}
